import { faker } from '@faker-js/faker'

import { AdminTreatmentPropertiesItem, OperationType } from '../../contracts/treatment'
import { asBuilder } from '../asBuilder'

export const getAdminTreatmentPropertiesItem = asBuilder((): AdminTreatmentPropertiesItem => {
  return {
    id: faker.number.int(),
    name: faker.lorem.word(),
    type: faker.helpers.enumValue(OperationType),
    unitProperty: {
      id: faker.string.uuid(),
      name: faker.lorem.word(),
      values: faker.helpers.multiple(() => ({
        value: faker.number.int(),
      })),
    },
    priceProperties: faker.helpers.multiple(() => ({
      id: faker.string.uuid(),
      name: faker.lorem.word(),
      multipleValuesAllowed: faker.datatype.boolean(),
      values: faker.helpers.multiple(() => ({
        id: faker.string.uuid(),
        name: faker.lorem.word(),
      })),
    })),
  }
})
